export default "__VITE_ASSET__gHxufDAa__"